import type { TranslationKey } from './translation-keys'
import type { Lang, LoadedTranslations } from './types'

export type TranslateParams = Record<string, string | number>

export type Translate = (key: TranslationKey, params?: TranslateParams) => string

export function createTranslator(lang: Lang, translations: LoadedTranslations | null): Translate {
  return (key, params) => interpolate(resolve(key, lang, translations), params)
}

function resolve(key: string, lang: Lang, translations: LoadedTranslations | null): string {
  const entry = translations?.[key]
  return text(entry?.[lang]) ?? text(entry?.nb) ?? text(entry?.en) ?? key
}

function text(value: string | null | undefined): string | undefined {
  return value ? value : undefined
}

function interpolate(template: string, params?: TranslateParams): string {
  if (!params) return template
  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => (name in params ? String(params[name]) : match))
}
